import _styled from "@emotion/styled/base";
import { jsx as _jsx, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import axios from 'axios';
import { Banner } from '../../components/UpliftAds/components/Banner/index.js';
export const UpliftAds = /*#__PURE__*/_styled(({
  advertisements,
  className = '',
  category = 'hero',
  width,
  height
}) => {
  if (!advertisements || advertisements.length <= 0) {
    return null;
  }
  return _jsx(_Fragment, {
    children: advertisements.map(advertisement => {
      const {
        adId,
        flightId,
        impressionUrl,
        viewableImpressionUrl,
        clickUrl,
        creativeContent
      } = advertisement;
      return _jsx(Banner, {
        category: category,
        content: {
          ...creativeContent[0],
          ctPrice: '450'
        },
        onClick: () => window.open(clickUrl),
        onRender: () => axios.get(impressionUrl),
        onHasBeenVisible: () => axios.get(viewableImpressionUrl),
        className: `FID_${flightId} ${className}`,
        width: width,
        height: height
      }, adId);
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e1y35wp30"
} : {
  target: "e1y35wp30",
  label: "UpliftAds"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlVwbGlmdEFkcy5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFZRyIsImZpbGUiOiJVcGxpZnRBZHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCwgRnJhZ21lbnQgYXMgX0ZyYWdtZW50IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgYXhpb3MgZnJvbSAnYXhpb3MnO1xuaW1wb3J0IHsgQmFubmVyIH0gZnJvbSAnLi4vLi4vY29tcG9uZW50cy9VcGxpZnRBZHMvY29tcG9uZW50cy9CYW5uZXIvaW5kZXguanMnO1xuZXhwb3J0IGNvbnN0IFVwbGlmdEFkcyA9IHN0eWxlZCgoeyBhZHZlcnRpc2VtZW50cywgY2xhc3NOYW1lID0gJycsIGNhdGVnb3J5ID0gJ2hlcm8nLCB3aWR0aCwgaGVpZ2h0LCB9KSA9PiB7XG4gICAgaWYgKCFhZHZlcnRpc2VtZW50cyB8fCBhZHZlcnRpc2VtZW50cy5sZW5ndGggPD0gMCkge1xuICAgICAgICByZXR1cm4gbnVsbDtcbiAgICB9XG4gICAgcmV0dXJuIChfanN4KF9GcmFnbWVudCwgeyBjaGlsZHJlbjogYWR2ZXJ0aXNlbWVudHMubWFwKChhZHZlcnRpc2VtZW50KSA9PiB7XG4gICAgICAgICAgICBjb25zdCB7IGFkSWQsIGZsaWdodElkLCBpbXByZXNzaW9uVXJsLCB2aWV3YWJsZUltcHJlc3Npb25VcmwsIGNsaWNrVXJsLCBjcmVhdGl2ZUNvbnRlbnQsIH0gPSBhZHZlcnRpc2VtZW50O1xuICAgICAgICAgICAgcmV0dXJuIChfanN4KEJhbm5lciwgeyBjYXRlZ29yeTogY2F0ZWdvcnksIGNvbnRlbnQ6IHsgLi4uY3JlYXRpdmVDb250ZW50WzBdLCBjdFByaWNlOiAnNDUwJyB9LCBvbkNsaWNrOiAoKSA9PiB3aW5kb3cub3BlbihjbGlja1VybCksIG9uUmVuZGVyOiAoKSA9PiBheGlvcy5nZXQoaW1wcmVzc2lvblVybCksIG9uSGFzQmVlblZpc2libGU6ICgpID0+IGF4aW9zLmdldCh2aWV3YWJsZUltcHJlc3Npb25VcmwpLCBjbGFzc05hbWU6IGBGSURfJHtmbGlnaHRJZH0gJHtjbGFzc05hbWV9YCwgd2lkdGg6IHdpZHRoLCBoZWlnaHQ6IGhlaWdodCB9LCBhZElkKSk7XG4gICAgICAgIH0pIH0pKTtcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9VXBsaWZ0QWRzLmpzLm1hcCJdfQ== */");